import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api/api.service';
import {
  RuleActionTypes,
  LoadFail,
  LoadSuccess
} from '@core/actions/rule.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class RuleEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(RuleActionTypes.Load),
    switchMap(() =>
      this.api.getRules().pipe(
        map((rules: any) => new LoadSuccess(rules)),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );

  constructor(private actions$: Actions, private api: ApiService) {}
}
